// // src\components\account\input\MultipleFileUploadInput.tsx
// "use client";
// import { Button } from "@/components/ui/button";
// import { Loader2, PaperclipIcon, X } from "lucide-react";
// import { useRef, useState, useEffect } from "react";
// import { toast } from "sonner";
// import Image from "next/image";
// import { ImageTs } from "@/core/types/imageTs";
// import { useDictionary } from "@/core/hooks/use-dictionary";
// import { uploadAttachment } from "@/core/lib/api/account/upload-attachment";

// interface FileUploadProps {
//   accept?: string;
//   disabled?: boolean;
//   multiple?: boolean;
//   onUploadSuccess?: (images: ImageTs[] | ImageTs | null) => void;
//   onFilesChange?: (files: File[] | null) => void;
//   error?: string;
//   defaultImages?: ImageTs[];
//   onDefaultRemove?: (id: number) => void;
//   iconOnly?: boolean;
//   compact?: boolean;
// }

// export default function FileUploadInput({
//   accept = "image/*,video/*",
//   disabled,
//   multiple = false,
//   onUploadSuccess,
//   onFilesChange,
//   error,
//   defaultImages = [],
//   onDefaultRemove,
//   iconOnly = false,
//   compact = false
// }: FileUploadProps) {
//   const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
//   const [isUploading, setIsUploading] = useState(false);
//   const [currentDefaultImages, setCurrentDefaultImages] =
//     useState<ImageTs[]>(defaultImages);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const { dictionary } = useDictionary();

//   // همگام‌سازی currentDefaultImages با defaultImages
//   useEffect(() => {
//     setCurrentDefaultImages(defaultImages);
//   }, [defaultImages]);

//   const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = Array.from(e.target.files || []);
//     setSelectedFiles(files);
//     onFilesChange?.(files.length ? files : null);

//     if (!files.length) {
//       onUploadSuccess?.(null);
//       if (fileInputRef.current) fileInputRef.current.value = "";
//       return;
//     }

//     // فقط اولین فایل انتخاب‌شده رو پردازش می‌کنیم
//     const file = files[0];

//     // اطلاع‌رسانی اگر چند فایل انتخاب شده
//     if (files.length > 1) {
//       toast.info(dictionary.common?.onlyFirstFileUploaded);
//     }

//     // اعتبارسنجی فایل
//     const validTypes = ["image/", "video/"];
//     if (file.size > 15 * 1024 * 1024) {
//       toast.error(dictionary.ui?.form.maxSizeError);
//       resetFiles();
//       return;
//     }
//     if (!validTypes.some((type) => file.type.startsWith(type))) {
//       toast.error(dictionary.ui?.form.invalidFileType);
//       resetFiles();
//       return;
//     }

//     setIsUploading(true);
//     try {
//       const result = await uploadAttachment(file, "");
//       if (result?.status === "success") {
//         toast.success(result.message || dictionary.common?.uploadSuccess);
//         onUploadSuccess?.(multiple ? [result.data] : result.data);

//         // تغییر اصلی: بر اساس multiple، append یا replace کن
//         setCurrentDefaultImages((prev) =>
//           multiple
//             ? [...prev, result.data]  // append برای multiple
//             : [result.data]           // replace برای single
//         );

//         // resetFiles(false)
//         resetFiles(); // ریست کردن فایل‌های انتخاب‌شده بعد از آپلود
//       } else {
//         const errorMessage = result?.message || dictionary.common?.uploadError;
//         toast.error(errorMessage);
//         resetFiles();
//       }
//     } catch (error: any) {
//       let errorMessage = dictionary.common?.uploadError;

//       if (error?.message) {
//         errorMessage = error.message;
//       } else if (error?.code === 'ECONNABORTED') {
//         errorMessage = dictionary.common?.uploadTimeoutError;
//       } else if (error?.response?.data?.message) {
//         errorMessage = error.response.data.message;
//       }

//       toast.error(errorMessage);
//       resetFiles();
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const resetFiles = () => {
//     setSelectedFiles([]);
//     onFilesChange?.(null);
//     onUploadSuccess?.(null);
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   };

//   // const resetFiles = (notifyParent = true) => {
//   //   setSelectedFiles([]);
//   //   onFilesChange?.(null);
//   //   if (fileInputRef.current) fileInputRef.current.value = "";
//   // };

//   const removeFile = (index: number) => {
//     const newFiles = selectedFiles.filter((_, i) => i !== index);
//     setSelectedFiles(newFiles);
//     onFilesChange?.(newFiles.length ? newFiles : null);
//   };

//   const handleDefaultRemove = (id: number) => {
//     setCurrentDefaultImages((prev) => {
//       const newImages = prev.filter((img) => img.id !== id);
//       return newImages;
//     });
//     onDefaultRemove?.(id);
//   };

//   if (iconOnly) {
//     return (
//       <div>
//         <Button
//           type="button"
//           variant="ghost"
//           size="icon"
//           disabled={disabled || isUploading}
//           onClick={() => fileInputRef.current?.click()}
//         >
//           {isUploading ? (
//             <Loader2 className="animate-spin h-4 w-4" />
//           ) : (
//             <PaperclipIcon className="h-4 w-4" />
//           )}
//         </Button>
//         <input
//           ref={fileInputRef}
//           type="file"
//           accept={accept}
//           multiple={multiple}
//           onChange={handleFileChange}
//           disabled={disabled || isUploading}
//           className="hidden"
//         />
//       </div>
//     );
//   }

//   return (
//     <div className={compact ? "space-y-1" : "space-y-2"}>
//       <div
//         className={
//           compact
//             ? `border-2 border-dashed rounded-lg p-2 ${error ? "border-red-300" : "border-gray-300"}`
//             : `border-2 border-dashed rounded-lg p-4 ${error ? "border-red-300" : "border-gray-300"}`
//         }
//       >

//         <div className="text-center">
//           {!compact && (<p className="text-sm text-gray-500 mb-3">
//             {dictionary.ui?.form.fileGuideline}
//           </p>)}

//           <Button
//             type="button"
//             variant="outline"
//             disabled={disabled || isUploading}
//             onClick={() => fileInputRef.current?.click()}
//             className={compact ? "mb-1 h-7 px-2 text-xs" : "mb-3"}
//           >
//             {isUploading ? (
//               <Loader2 className={compact ? "animate-spin h-3 w-3 mr-1" : "animate-spin h-4 w-4 mr-2"} />
//             ) : (
//               <PaperclipIcon className={compact ? "h-3 w-3 mr-0.5" : "h-4 w-4 mr-2"} />
//             )}
//             {dictionary.ui?.form.selectFile}
//           </Button>
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept={accept}
//             multiple={multiple}
//             onChange={handleFileChange}
//             disabled={disabled || isUploading}
//             className="hidden"
//           />
//         </div>
//         {(selectedFiles.length > 0 || currentDefaultImages.length > 0) && (
//           <div className={compact ? "mt-2 space-y-1" : "mt-4 space-y-2"}>
//             {/* Render selected files */}
//             {selectedFiles.map((file, index) => {
//               const imageSrc = URL.createObjectURL(file);
//               return (
//                 <div
//                   key={`selected-${index}`}
//                   className={`${compact ? 'p-2' : 'p-3'} bg-gray-50 rounded-md flex items-center justify-between gap-2`}
//                 >
//                   <div className="flex items-center space-x-3 flex-1 min-w-0">
//                     {file.type.startsWith("video/") ? (
//                       <video
//                         src={imageSrc}
//                         className={`${compact ? "w-10 h-10" : "w-14 h-14"} rounded shrink-0 object-cover`}
//                         muted
//                         autoPlay
//                         loop
//                       />
//                     ) : (
//                       <div className={`relative shrink-0 ${compact ? "w-10 h-10" : "w-14 h-14"}`}>
//                         <Image
//                           src={imageSrc}
//                           alt="Preview"
//                           fill
//                           className="object-cover rounded"
//                         />
//                       </div>
//                     )}
//                     <div className="min-w-0 flex-1">
//                       <p className={`text-sm font-medium truncate ${compact ? "max-w-[120px]" : ""}`}>
//                         {file.name}
//                       </p>
//                       {!compact && (
//                         <p className="text-xs text-gray-500">
//                           {(file.size / 1024).toFixed(2)} KB
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                   <Button
//                     type="button"
//                     variant="ghost"
//                     size="sm"
//                     onClick={() => removeFile(index)}
//                     disabled={isUploading}
//                     className="shrink-0"
//                   >
//                     <X className={compact ? "h-3 w-3" : "h-4 w-4"} />
//                   </Button>
//                 </div>
//               );
//             })}
//             {/* Render uploaded images */}
//             {currentDefaultImages.length > 0 && (
//               <>
//                 {currentDefaultImages.map((image) => {
//                   if (!image.url) return null;
//                   return (
//                     <div
//                       key={`default-${image.id}`}
//                       className={`${compact ? "p-2" : "p-3"} bg-gray-50 rounded-md flex items-center justify-between gap-2`}
//                     >
//                       <div className="flex items-center space-x-3 flex-1 min-w-0">
//                         {image.url.endsWith(".mp4") ? (
//                           <video
//                             src={image.url}
//                             className={`${compact ? "w-10 h-10" : "w-14 h-14"} rounded shrink-0 object-cover`}
//                             muted
//                             autoPlay
//                             loop
//                           />
//                         ) : (
//                           <div className={`relative shrink-0 ${compact ? "w-10 h-10" : "w-14 h-14"}`}>
//                             <Image
//                               src={image.url}
//                               alt="Preview"
//                               fill
//                               className="object-cover rounded"
//                             />
//                           </div>
//                         )}
//                         <div className="min-w-0 flex-1">
//                           {image.name && (
//                             <p className="text-xs font-medium truncate">
//                               {image.name}
//                             </p>
//                           )}
//                         </div>
//                       </div>
//                       <Button
//                         type="button"
//                         variant="ghost"
//                         size="sm"
//                         onClick={() => handleDefaultRemove(image.id)}
//                         disabled={isUploading}
//                         className="shrink-0"
//                       >
//                         <X className={compact ? "h-3 w-3" : "h-4 w-4"} />
//                       </Button>
//                     </div>
//                   );
//                 })}
//               </>
//             )}
//           </div>
//         )}
//       </div>
//       {error && <p className="text-sm text-red-600">{error}</p>}
//     </div>
//   );
// }





// src\components\account\input\MultipleFileUploadInput.tsx
"use client";
import { Button } from "@/components/ui/button";
import { Loader2, PaperclipIcon, X, ImageUp, CheckCircle2 } from "lucide-react";
import { useRef, useState, useEffect } from "react";
import { toast } from "sonner";
import Image from "next/image";
import { ImageTs } from "@/core/types/imageTs";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { uploadAttachment } from "@/core/lib/api/account/upload-attachment";

interface FileUploadProps {
  accept?: string;
  disabled?: boolean;
  multiple?: boolean;
  onUploadSuccess?: (images: ImageTs[] | ImageTs | null) => void;
  onFilesChange?: (files: File[] | null) => void;
  error?: string;
  defaultImages?: ImageTs[];
  onDefaultRemove?: (id: number) => void;
  iconOnly?: boolean;
  compact?: boolean;
  /**
   * "default" = رفتار قبلی (کادر آپلود + لیست ردیفی از فایل‌ها)
   * "cover"   = یک باکس مربعی که خودِ تصویر رو به صورت کاور نشون میده (فقط برای multiple=false)
   * "grid"    = گرید مربع‌های تصویر + یک باکس «افزودن» در انتها (فقط برای multiple=true)
   */
  variant?: "default" | "cover" | "grid";
}

export default function FileUploadInput({
  accept = "image/*,video/*",
  disabled,
  multiple = false,
  onUploadSuccess,
  onFilesChange,
  error,
  defaultImages = [],
  onDefaultRemove,
  iconOnly = false,
  compact = false,
  variant = "default",
}: FileUploadProps) {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  // وضعیت نمایشی آپلود: idle (کاری در جریان نیست) / uploading (در حال
  // آپلود) / success (تازه با موفقیت تموم شده، چند ثانیه نشون داده می‌شه)
  const [uploadStatus, setUploadStatus] = useState<'idle' | 'uploading' | 'success'>('idle');
  const successTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [currentDefaultImages, setCurrentDefaultImages] =
    useState<ImageTs[]>(defaultImages);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { dictionary } = useDictionary();

  // همگام‌سازی currentDefaultImages با defaultImages
  useEffect(() => {
    setCurrentDefaultImages(defaultImages);
  }, [defaultImages]);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    setSelectedFiles(files);
    onFilesChange?.(files.length ? files : null);

    if (!files.length) {
      onUploadSuccess?.(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    // فقط اولین فایل انتخاب‌شده رو پردازش می‌کنیم
    const file = files[0];

    // اطلاع‌رسانی اگر چند فایل انتخاب شده
    if (files.length > 1) {
      toast.info(dictionary.common?.onlyFirstFileUploaded);
    }

    // اعتبارسنجی فایل
    const validTypes = ["image/", "video/"];
    if (file.size > 15 * 1024 * 1024) {
      toast.error(dictionary.ui?.form.maxSizeError);
      resetFiles();
      return;
    }
    if (!validTypes.some((type) => file.type.startsWith(type))) {
      toast.error(dictionary.ui?.form.invalidFileType);
      resetFiles();
      return;
    }

    setIsUploading(true);
    setUploadStatus('uploading');
    try {
      const result = await uploadAttachment(file, "");
      if (result?.status === "success") {
        toast.success(result.message || dictionary.common?.uploadSuccess);
        onUploadSuccess?.(multiple ? [result.data] : result.data);

        // تغییر اصلی: بر اساس multiple، append یا replace کن
        setCurrentDefaultImages((prev) =>
          multiple
            ? [...prev, result.data]  // append برای multiple
            : [result.data]           // replace برای single
        );

        // resetFiles(false)
        resetFiles(); // ریست کردن فایل‌های انتخاب‌شده بعد از آپلود

        // نمایش تیک موفقیت برای چند ثانیه
        setUploadStatus('success');
        if (successTimerRef.current) clearTimeout(successTimerRef.current);
        successTimerRef.current = setTimeout(() => setUploadStatus('idle'), 1800);
      } else {
        const errorMessage = result?.message || dictionary.common?.uploadError;
        toast.error(errorMessage);
        resetFiles();
        setUploadStatus('idle');
      }
    } catch (error: any) {
      let errorMessage = dictionary.common?.uploadError;

      if (error?.message) {
        errorMessage = error.message;
      } else if (error?.code === 'ECONNABORTED') {
        errorMessage = dictionary.common?.uploadTimeoutError;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      toast.error(errorMessage);
      resetFiles();
      setUploadStatus('idle');
    } finally {
      setIsUploading(false);
    }
  };

  const resetFiles = () => {
    setSelectedFiles([]);
    onFilesChange?.(null);
    onUploadSuccess?.(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // const resetFiles = (notifyParent = true) => {
  //   setSelectedFiles([]);
  //   onFilesChange?.(null);
  //   if (fileInputRef.current) fileInputRef.current.value = "";
  // };

  const removeFile = (index: number) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
    onFilesChange?.(newFiles.length ? newFiles : null);
  };

  const handleDefaultRemove = (id: number) => {
    setCurrentDefaultImages((prev) => {
      const newImages = prev.filter((img) => img.id !== id);
      return newImages;
    });
    onDefaultRemove?.(id);
  };

  // پاکسازی تایمرِ تیک موفقیت هنگام unmount
  useEffect(() => {
    return () => {
      if (successTimerRef.current) clearTimeout(successTimerRef.current);
    };
  }, []);

  if (iconOnly) {
    return (
      <div>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          disabled={disabled || isUploading}
          onClick={() => fileInputRef.current?.click()}
        >
          {isUploading ? (
            <Loader2 className="animate-spin h-4 w-4" />
          ) : (
            <PaperclipIcon className="h-4 w-4" />
          )}
        </Button>
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          multiple={multiple}
          onChange={handleFileChange}
          disabled={disabled || isUploading}
          className="hidden"
        />
      </div>
    );
  }

  // ---------------------------------------------------------------------
  // variant="cover" -> باکس مربعی که خودش پیش‌نمایش تصویر رو نشون میده
  // (فقط برای حالت تک‌فایلی؛ برای multiple به رفتار پیش‌فرض برمی‌گرده)
  // ---------------------------------------------------------------------
  if (variant === "cover" && !multiple) {
    const previewFile = selectedFiles[0];
    const previewImage = currentDefaultImages[0];
    const previewSrc = previewFile
      ? URL.createObjectURL(previewFile)
      : previewImage?.url;
    const hasPreview = Boolean(previewSrc);
    // فایل انتخاب‌شده یا تصویر پیش‌فرض ممکنه ویدئو باشه (مثلاً برای
    // «عکس هاور» که هم عکس هم ویدئو رو می‌پذیره)؛ باید با <video> نمایش
    // داده بشه، نه <Image>، وگرنه پیش‌نمایش خراب می‌شه.
    const previewIsVideo = previewFile
      ? previewFile.type.startsWith("video/")
      : Boolean(previewImage?.url && /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(previewImage.url));

    const handleRemoveCover = () => {
      if (previewFile) {
        removeFile(0);
      }
      if (previewImage) {
        handleDefaultRemove(previewImage.id);
      }
    };

    return (
      <div className="space-y-2">
        <div
          onClick={() => !hasPreview && !disabled && !isUploading && fileInputRef.current?.click()}
          className={`relative aspect-square w-full rounded-xl border-2 border-dashed overflow-hidden flex items-center justify-center bg-gray-50 transition-colors ${error ? "border-red-300" : "border-gray-300"
            } ${!hasPreview ? "cursor-pointer hover:bg-gray-100" : ""}`}
        >
          {hasPreview ? (
            <>
              {previewIsVideo ? (
                <video
                  src={previewSrc as string}
                  className="absolute inset-0 h-full w-full object-cover"
                  muted
                  autoPlay
                  loop
                  playsInline
                />
              ) : (
                <Image
                  src={previewSrc as string}
                  alt="Preview"
                  fill
                  className="object-cover"
                />
              )}

              {/* وضعیت آپلود روی خودِ پیش‌نمایش */}
              {uploadStatus === 'uploading' && (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-black/50 text-white">
                  <Loader2 className="h-6 w-6 animate-spin" />
                  <span className="text-xs font-medium">
                    {dictionary.ui?.form.uploading || 'در حال آپلود...'}
                  </span>
                </div>
              )}
              {uploadStatus === 'success' && (
                <div className="absolute top-2 right-2 flex items-center gap-1 rounded-full bg-emerald-600 text-white px-2 py-1 text-xs font-medium shadow">
                  <CheckCircle2 className="h-3.5 w-3.5" />
                  {dictionary.ui?.form.uploadDone || 'آپلود کامل شد'}
                </div>
              )}

              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveCover();
                }}
                disabled={isUploading}
                className="absolute top-2 left-2 flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-white hover:bg-black/80"
              >
                <X className="h-4 w-4" />
              </button>
            </>
          ) : isUploading ? (
            <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
          ) : (
            <div className="flex flex-col items-center gap-2 px-4 text-center">
              <ImageUp className="h-6 w-6 text-gray-400" />
              <span className="text-sm font-medium text-gray-600">
                {dictionary.ui?.form.selectFile}
              </span>
              <span className="text-xs text-gray-400">
                {dictionary.ui?.form.fileGuideline}
              </span>
            </div>
          )}
        </div>
        {hasPreview && (previewFile?.name || previewImage?.name) && (
          <p className="text-xs text-gray-500 truncate px-1">
            {previewFile?.name || previewImage?.name}
          </p>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          multiple={false}
          onChange={handleFileChange}
          disabled={disabled || isUploading}
          className="hidden"
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  }

  // ---------------------------------------------------------------------
  // variant="cover" + multiple -> گرید مربعی از تصاویر با یک باکس «افزودن»
  // ---------------------------------------------------------------------
  if (variant === "cover" && multiple) {
    const galleryItems: {
      key: string;
      src: string;
      isVideo: boolean;
      onRemove: () => void;
    }[] = [
        ...currentDefaultImages
          .filter((img) => Boolean(img.url))
          .map((img) => ({
            key: `default-${img.id}`,
            src: img.url as string,
            isVideo: /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(img.url as string),
            onRemove: () => handleDefaultRemove(img.id),
          })),
        ...selectedFiles.map((file, index) => ({
          key: `selected-${index}`,
          src: URL.createObjectURL(file),
          isVideo: file.type.startsWith("video/"),
          onRemove: () => removeFile(index),
        })),
      ];

    return (
      <div className="space-y-2">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-3">
          {galleryItems.map((item) => (
            <div
              key={item.key}
              className="relative aspect-square rounded-xl border border-gray-200 overflow-hidden bg-gray-50"
            >
              {item.isVideo ? (
                <video
                  src={item.src}
                  className="absolute inset-0 h-full w-full object-cover"
                  muted
                  autoPlay
                  loop
                  playsInline
                />
              ) : (
                <Image src={item.src} alt="Preview" fill className="object-cover" />
              )}
              <button
                type="button"
                onClick={() => item.onRemove()}
                disabled={isUploading}
                className="absolute top-2 left-2 flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-white hover:bg-black/80"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          ))}

          <div
            onClick={() => !disabled && !isUploading && fileInputRef.current?.click()}
            className={`relative aspect-square rounded-xl border-2 border-dashed flex items-center justify-center bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors ${error ? "border-red-300" : "border-gray-300"
              }`}
          >
            {isUploading ? (
              <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
            ) : (
              <div className="flex flex-col items-center gap-2 px-3 text-center">
                <ImageUp className="h-6 w-6 text-gray-400" />
                <span className="text-xs font-medium text-gray-600">
                  {dictionary.ui?.form.selectFile}
                </span>
                <span className="text-xs text-gray-400">
                  {dictionary.ui?.form.fileGuideline}
                </span>
              </div>

            )}
          </div>
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          multiple={false}
          onChange={handleFileChange}
          disabled={disabled || isUploading}
          className="hidden"
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  }

  // ---------------------------------------------------------------------
  // variant="grid" -> گرید مربعی از تصاویر آپلودشده + یک باکس «افزودن»
  // (فقط برای حالت چندفایلی)
  // ---------------------------------------------------------------------
  if (variant === "grid" && multiple) {
    return (
      <div className="space-y-2 w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {currentDefaultImages.map((image) => {
            if (!image.url) return null;
            return (
              <div key={`default-${image.id}`} className="space-y-1">
                <div className="relative aspect-square w-full rounded-xl overflow-hidden border border-gray-200 bg-gray-50">
                  {image.url.endsWith(".mp4") ? (
                    <video
                      src={image.url}
                      className="w-full h-full object-cover"
                      muted
                      autoPlay
                      loop
                    />
                  ) : (
                    <Image
                      src={image.url}
                      alt="Preview"
                      fill
                      className="object-cover"
                    />
                  )}
                  <button
                    type="button"
                    onClick={() => handleDefaultRemove(image.id)}
                    disabled={isUploading}
                    className="absolute top-2 left-2 flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-white hover:bg-black/80"
                  >
                    <X className="h-4 w-4" />
                  </button>
                </div>
                {image.name && (
                  <p className="text-[10px] text-gray-500 truncate px-1">
                    {image.name}
                  </p>
                )}
              </div>
            );
          })}

          <div
            onClick={() => !disabled && !isUploading && fileInputRef.current?.click()}
            className={`relative aspect-square w-full rounded-xl border-2 border-dashed flex items-center justify-center bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors ${error ? "border-red-300" : "border-gray-300"
              }`}
          >
            {isUploading ? (
              <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
            ) : (
              <div className="flex flex-col items-center gap-2 px-4 text-center">
                <ImageUp className="h-6 w-6 text-gray-400" />
                <span className="text-sm font-medium text-gray-600">
                  {dictionary.ui?.form.selectFile}
                </span>
                <span className="text-xs text-gray-400">
                  {dictionary.ui?.form.fileGuideline}
                </span>
              </div>
            )}
          </div>
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          multiple={false}
          onChange={handleFileChange}
          disabled={disabled || isUploading}
          className="hidden"
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  }
  return (
    <div className={compact ? "space-y-1" : "space-y-2"}>
      <div
        className={
          compact
            ? `border-2 border-dashed rounded-lg p-2 ${error ? "border-red-300" : "border-gray-300"}`
            : `border-2 border-dashed rounded-lg p-4 ${error ? "border-red-300" : "border-gray-300"}`
        }
      >

        <div className="text-center">
          {!compact && (<p className="text-sm text-gray-500 mb-3">
            {dictionary.ui?.form.fileGuideline}
          </p>)}

          <Button
            type="button"
            variant="outline"
            disabled={disabled || isUploading}
            onClick={() => fileInputRef.current?.click()}
            className={compact ? "mb-1 h-7 px-2 text-xs" : "mb-3"}
          >
            {isUploading ? (
              <Loader2 className={compact ? "animate-spin h-3 w-3 mr-1" : "animate-spin h-4 w-4 mr-2"} />
            ) : (
              <PaperclipIcon className={compact ? "h-3 w-3 mr-0.5" : "h-4 w-4 mr-2"} />
            )}
            {dictionary.ui?.form.selectFile}
          </Button>
          <input
            ref={fileInputRef}
            type="file"
            accept={accept}
            multiple={multiple}
            onChange={handleFileChange}
            disabled={disabled || isUploading}
            className="hidden"
          />
        </div>
        {(selectedFiles.length > 0 || currentDefaultImages.length > 0) && (
          <div className={compact ? "mt-2 space-y-1" : "mt-4 space-y-2"}>
            {/* Render selected files */}
            {selectedFiles.map((file, index) => {
              const imageSrc = URL.createObjectURL(file);
              return (
                <div
                  key={`selected-${index}`}
                  className={`${compact ? 'p-2' : 'p-3'} bg-gray-50 rounded-md flex items-center justify-between gap-2`}
                >
                  <div className="flex items-center space-x-3 flex-1 min-w-0">
                    {file.type.startsWith("video/") ? (
                      <video
                        src={imageSrc}
                        className={`${compact ? "w-10 h-10" : "w-14 h-14"} rounded shrink-0 object-cover`}
                        muted
                        autoPlay
                        loop
                      />
                    ) : (
                      <div className={`relative shrink-0 ${compact ? "w-10 h-10" : "w-14 h-14"}`}>
                        <Image
                          src={imageSrc}
                          alt="Preview"
                          fill
                          className="object-cover rounded"
                        />
                      </div>
                    )}
                    <div className="min-w-0 flex-1">
                      <p className={`text-sm font-medium truncate ${compact ? "max-w-[120px]" : ""}`}>
                        {file.name}
                      </p>
                      {!compact && (
                        <p className="text-xs text-gray-500">
                          {(file.size / 1024).toFixed(2)} KB
                        </p>
                      )}
                    </div>
                  </div>
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={() => removeFile(index)}
                    disabled={isUploading}
                    className="shrink-0"
                  >
                    <X className={compact ? "h-3 w-3" : "h-4 w-4"} />
                  </Button>
                </div>
              );
            })}
            {/* Render uploaded images */}
            {currentDefaultImages.length > 0 && (
              <>
                {currentDefaultImages.map((image) => {
                  if (!image.url) return null;
                  return (
                    <div
                      key={`default-${image.id}`}
                      className={`${compact ? "p-2" : "p-3"} bg-gray-50 rounded-md flex items-center justify-between gap-2`}
                    >
                      <div className="flex items-center space-x-3 flex-1 min-w-0">
                        {image.url.endsWith(".mp4") ? (
                          <video
                            src={image.url}
                            className={`${compact ? "w-10 h-10" : "w-14 h-14"} rounded shrink-0 object-cover`}
                            muted
                            autoPlay
                            loop
                          />
                        ) : (
                          <div className={`relative shrink-0 ${compact ? "w-10 h-10" : "w-14 h-14"}`}>
                            <Image
                              src={image.url}
                              alt="Preview"
                              fill
                              className="object-cover rounded"
                            />
                          </div>
                        )}
                        <div className="min-w-0 flex-1">
                          {image.name && (
                            <p className="text-xs font-medium truncate">
                              {image.name}
                            </p>
                          )}
                        </div>
                      </div>
                      <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        onClick={() => handleDefaultRemove(image.id)}
                        disabled={isUploading}
                        className="shrink-0"
                      >
                        <X className={compact ? "h-3 w-3" : "h-4 w-4"} />
                      </Button>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}